var styles = {"unitsCount":"ep-pricing-module-units-count-dW5pd"};

export { styles as default };
